import { ActivityTypeListApiModel } from '../../site-settings/activity-types/ActivityTypeListApiModel';

export class RemedialActivitiesFiltersApiModel {
  public ActivityTypes: Array<ActivityTypeListApiModel>;
  public HasSkills: boolean;
  public HasPerformanceCategories: boolean;
  public HasCallTypes: boolean;

  public deserialize?(data: Object): RemedialActivitiesFiltersApiModel {
    Object.assign(this, data);

    this.ActivityTypes = this.ActivityTypes.map((x) => new ActivityTypeListApiModel().deserialize(x));

    return this;
  }
}
